/**
 * appToast.ts — Configuración global de react-hot-toast.
 *
 * QUÉ EXPORTA: clase CSS, opciones base y helper mergeToastOptions.
 * QUÉ NO DEBE HACER: disparar toasts ni lógica de negocio.
 *
 * Los estilos responsive (tipografía compacta en móvil) viven en index.css (.app-toast).
 */

import { createElement, type CSSProperties } from "react";
import { X } from "lucide-react";
import type { DefaultToastOptions, ToastOptions } from "react-hot-toast";

/** Clase aplicada a cada toast; enlazada con reglas en index.css */
export const APP_TOAST_CLASS = "app-toast";

/** Contenedor del Toaster (posición / z-index global) */
export const APP_TOASTER_CLASS = "app-toaster";

const baseStyle: CSSProperties = {
  background: "var(--surface-elevated)",
  color: "var(--text-primary)",
  border: "none",
};

/** Opciones por defecto del <Toaster /> — heredadas por todos los toast.* */
export const appToasterOptions: DefaultToastOptions = {
  duration: 3000,
  className: APP_TOAST_CLASS,
  style: baseStyle,
  success: {
    iconTheme: {
      primary: "#22c55e",
      secondary: "var(--surface-elevated)",
    },
  },
  error: {
    iconTheme: {
      primary: "#ef4444",
      secondary: "var(--surface-elevated)",
    },
  },
};

/** Fusiona opciones locales con la clase global (sin perder overrides). */
export const mergeToastOptions = (options?: ToastOptions): ToastOptions => ({
  ...options,
  className: [APP_TOAST_CLASS, options?.className].filter(Boolean).join(" "),
});

/** Icono circular rojo con ✕ — paridad visual con el check de éxito. */
export const AppToastRemoveIcon = () =>
  createElement(
    "span",
    { className: "app-toast-icon app-toast-icon--remove", "aria-hidden": true },
    createElement(X, { size: 13, strokeWidth: 3 }),
  );
